import { OverlayContainer } from '@angular/cdk/overlay';

export class CdkOverlayContainer extends OverlayContainer {
  override getContainerElement(): HTMLElement {
    if (this.#checkIsOtherComponentExist()) {
      this._containerElement = this._document.querySelector('.cdk-overlay-container') as HTMLElement;

      return this._containerElement;
    }

    const webComponent = this._document.querySelector('pu-floating-button-webcomponent');
    const overlayContainer = webComponent?.shadowRoot?.getElementById('pu-floating-button__overlay-container');
    if (!overlayContainer) {
      this.#createCustomContainer();
    }

    return this._containerElement;
  }

  #checkIsOtherComponentExist(): boolean {
    const webComponent = this._document.querySelector('pu-create-request-form-webcomponent');

    return !!webComponent;
  }

  #createCustomContainer() {
    const webComponent = this._document.querySelector('pu-floating-button-webcomponent');
    const webComponentInnerWrapper = webComponent?.shadowRoot?.getElementById('pu-floating-button__shell');
    const container = this._document.createElement('div');
    container.setAttribute('id', 'pu-floating-button__overlay-container');
    container.classList.add('cdk-overlay-container', 'pu-floating-button__overlay-container');
    webComponentInnerWrapper?.appendChild(container);
    this._containerElement = container;
  }
}
